import { cn } from "@/utils/cn";
import type { WizardStep } from "./model";

export function StepDots({ step }: { step: WizardStep }) {
  return (
    <div className="flex items-center gap-1" aria-hidden>
      {[1, 2, 3].map((item) => (
        <span
          key={item}
          className={cn(
            "h-1.5 rounded-full transition-all",
            item === step ? "trial-brand-gradient w-5" : item < step ? "w-1.5 bg-[var(--trial-brand)]" : "w-1.5 bg-white/70",
          )}
        />
      ))}
    </div>
  );
}
